export default {
  UPDATING_REAL_TIME_ORDER_STATE: 'CONTROL_VIEW_STATE_UPDATING_REAL_TIME_ORDER_STATE',
  UPDATED_REAL_TIME_ORDER_STATE: 'CONTROL_VIEW_STATE_UPDATED_REAL_TIME_ORDER_STATE',
};
